import { Typography } from "@codat/orchard-ui";
import classNames from "classnames";

import styles from "./ConnectionComplete.module.css";

interface ConnectionCompleteProps {
  Icon?: React.FC<{ className: string }>;
  title: string;
  className?: string;
}

export const ConnectionComplete = ({
  Icon,
  title,
  children,
  className,
}: React.PropsWithChildren<ConnectionCompleteProps>) => {
  return (
    <div
      className={classNames(styles.container, className)}
      data-testid="connection-complete"
    >
      {Icon && <Icon className={styles.icon} />}
      <Typography
        className={styles.title}
        data-testid="page-title"
        variant="h2"
        as="h2"
      >
        {title}
      </Typography>
      <section className={styles.body}>{children}</section>
    </div>
  );
};
